<template>
    <div
        class="font-medium cursor-pointer" 
        :class="rowClass"
        @click="selectRow"
     >
        {{ rowLabel }}
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, watch } from 'vue';

const props = defineProps(['row', 'selectedRow'])
const emit = defineEmits(['select-row'])


const rowLabel = computed(() => {
    return props.row ? props.row.label : '--'
})


const rowClass = computed(() => {
    return props.row && props.selectedRow ? props.row.id == props.selectedRow.id ? 'text-indigo-600 font-semibold tracking-wide cursor-pointer' : 'text-gray-700 hover:text-gray-900' : 'text-gray-700 hover:text-gray-900'
})

function selectRow() {
    emit('select-row', props.row.id)
}


</script>